import React from "react"
import { useEffect, useRef } from "react"

{
  /* The orange blurred circle in the top right corner of most pages. It extends into the section beneath the Header, so it is not part of HeaderSection. */
}
const TopRightPageBg = () => {
  const topRightPageBgRef = useRef(null)
  //get the parent container and set position to relative and z-index to 0
  //this will allow the bubbles to be behind the content
  useEffect(() => {
    const parent = topRightPageBgRef.current.parentElement
    parent.style.position = "relative"
    parent.style.zIndex = 0
  }, [])

  return (
    <div
      ref={topRightPageBgRef}
      className="absolute right-[-300px] top-0 h-[300px] w-[300px] rounded-full bg-orange_primary/70"
      style={{ filter: "blur(250px)" }}
    />
  )
}

export default TopRightPageBg
